<template>
  <v-card outlined tile class="d-flex justify-start">
    <v-select
      :items="wsStatusItems"
      item-text="DS_NAME"
      item-value="DS_ID"
      v-model="value"
      label="Статус конфигурации"
      no-data-text="Нет данных"
      class="pl-3 pr-3"
    ></v-select>
  </v-card>
</template>

<script>
import { RCPT_GET_RCPT_STATUS_LIST, RCPT_SET_FILTER } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'wsStatusSelector',
  props: ['setGlobalFilter'],
  data () {
    return {
    }
  },
  computed: {
    value: {
      get: function () {
        const currStatus = this.$store.getters.getCurrentRecepturesStateFilter
        return currStatus
      },
      set: function (val) {
        this.$emit('input', val)
        if (this.setGlobalFilter) this.$store.dispatch(RCPT_SET_FILTER, { DS_ID: val })
      }
    },
    wsStatusItems: {
      get: function () {
        return this.$store.getters.getRecepturesStatesList
      }
    }
  },
  mounted: function () {
    const self = this
    if (this.wsStatusItems.length === 0) {
      this.$store.dispatch(RCPT_GET_RCPT_STATUS_LIST)
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка статусов рецептур: \n ${err}` })
        })
    }
  }
}
</script>
